export const selectors = {
	activeItem: '.anchor-navigation__item.active',
	footer: 'footer.footer',
	header: 'header.header',
	highlightSection: 'section[data-color-scheme="highlight"]',
	item: '.anchor-navigation__item',
	nav: '.anchor-navigation',
};

export const classes = {
	hide: 'hide',
	show: 'show',
	active: 'active',
};
